var map = {
	"./gallery-wip-neck-ring_00.jpg": 2778,
	"./gallery-wip-neck-ring_01.jpg": 2779,
	"./gallery-wip-neck-ring_02.jpg": 2780,
	"./gallery-wip-neck-ring_03.jpg": 2781,
	"./gallery-wip-neck-ring_04.jpg": 2782,
	"./gallery_00.jpg": 2783,
	"./gallery_01.jpg": 2784,
	"./gallery_02.jpg": 2785,
	"./gallery_03.jpg": 2786,
	"./gallery_04.jpg": 2787
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2777;